import { defineComponent as _defineComponent } from 'vue';
import AzImg from '~/components/Atoms/AzImg.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AdviceCardGraphQL',
  props: {
    advice: {
      type: Object,
      default: function _default() {}
    },
    imageLoading: {
      type: String,
      required: false,
      default: 'lazy'
    },
    condensed: {
      type: Boolean,
      default: false
    },
    isTargetBlank: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      $trackers = _useNuxt2App.$trackers;
    var route = useRoute();
    var adviceAttribute = computed(function () {
      var _props$advice, _props$advice$parentA;
      return (_props$advice = props.advice) === null || _props$advice === void 0 ? void 0 : (_props$advice$parentA = _props$advice.parentAdviceListingPage) === null || _props$advice$parentA === void 0 ? void 0 : _props$advice$parentA.title;
    });
    var pageUrl = route.fullPath;
    return {
      __sfc: true,
      props: props,
      app: app,
      $trackers: $trackers,
      route: route,
      adviceAttribute: adviceAttribute,
      pageUrl: pageUrl,
      AzImg: AzImg,
      NuxtLinkCustom: NuxtLinkCustom
    };
  }
});